const userColumns = [
	{ field: 'userId', header: 'User ID' },
	{ field: 'userName', header: 'User Name' },
	{ field: 'userRole', header: 'User Role' },
	{ field: 'createdBy', header: 'Created By' },
];

export default userColumns;
